import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class SummaryService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadDataSummary(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/asn/summary`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	loadDataSummaryDetails(invoiceNumber, supplier): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/asn/summary/details/${invoiceNumber}/${supplier}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	deleteSummary(invoiceNumber): Observable<any> {
		return this.http
			.delete(`${this.constantsService.baseAPIURL}/export/asn/summary/${invoiceNumber}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	loadDataSummaryHistoryLogs(po, poLine, backNumber): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/asn/summary/inDetails/${po}/${poLine}/${backNumber}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}


}
